import { setupProductRequestForm } from './components/product-request-form';
import { setupResponsiveTables } from './components/table';
import { onReady } from './utils/on-ready';

function init() {
    onReady(() => {
        setupProductRequestForm();
        setupResponsiveTables();
    });
}

init();
